import Link, {LinkProps} from '@mui/material/Link';
import React from 'react';

const SUPPORT_EMAIL = 'support@culturello.com';
export const SupportEmailLink = (
  props: Omit<LinkProps, 'href' | 'children'>,
) => (
  <Link href={`mailto:${SUPPORT_EMAIL}`} {...props}>
    {SUPPORT_EMAIL}
  </Link>
);
